export default {
  namespaced: true,
  state: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "success",
      timeout: 3000
    }
  }),
  mutations: {
    SHOW_SNACKBAR(state, payload) {
      state.snackbar = {
        show: true,
        text: payload.text || "",
        color: payload.color || "success",
        timeout: payload.timeout || 3000
      };
    },
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false;
    }
  },
  actions: {
    showSnackbar({ commit }, payload) {
      commit("SHOW_SNACKBAR", payload);
    },
    hideSnackbar({ commit }) {
      commit("HIDE_SNACKBAR");
    }
  }
};